import React from "react";
import { motion } from "framer-motion";
import { captcha_grid } from "./animation.config";

export const HeroContent = () => (
  <div className="absolute top-28 md:top-32 w-full flex flex-col items-center text-center md:items-end md:text-right px-4 md:px-6 lg:px-8">
    <motion.div 
      className="pointer-events-auto max-w-full"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
      {/* Main Headline */}
      <h1 className="font-pixel text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl mb-2 md:mb-4">
        <span className="bg-gradient-to-r from-cyan-400 via-teal-300 to-white bg-clip-text text-transparent">
          CaptchaSonic
        </span>
      </h1>
      {/* Sub-headline */}
      <motion.div 
        className="font-kodeMono text-lg sm:text-xl md:text-2xl text-white/90 max-w-md md:max-w-xl"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
      >
        <span>The Ultimate </span>
        <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-300">
          CAPTCHA Solving Service
        </span>
        <span> and RPA Assistant</span>
      </motion.div>
    </motion.div>

    {/* Phone promo image */}
    <motion.div 
      className="h-[30vh] w-[90vw] mb-20 opacity-45 md:hidden"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 0.45, scale: 1 }}
      transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
    >
      <img src={captcha_grid} alt="Captcha Grid Example" />
    </motion.div>
  </div>
);